let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1v184")).then(() => parcelRequire('bYkUJ'));